export default "__VITE_ASSET__BR3AoG1l__"